 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"caracteristicas~categorias~clientes~configuracoes~core~core-login~dashboard~formas-entregas~formas-p~ec1d178a":"caracteristicas~categorias~clientes~configuracoes~core~core-login~dashboard~formas-entregas~formas-p~ec1d178a","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~c35de80f":"caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~c35de80f","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~aee28681":"caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~aee28681","caracteristicas~personalizacoes":"caracteristicas~personalizacoes","caracteristicas":"caracteristicas","categorias~usuarios":"categorias~usuarios","categorias":"categorias","usuarios":"usuarios","clientes":"clientes","configuracoes~formas-entregas~formas-pagamentos~produtos~regras-fretes~regras-precos~tabelas-precos":"configuracoes~formas-entregas~formas-pagamentos~produtos~regras-fretes~regras-precos~tabelas-precos","configuracoes":"configuracoes","formas-entregas":"formas-entregas","formas-pagamentos":"formas-pagamentos","produtos":"produtos","regras-fretes":"regras-fretes","regras-precos":"regras-precos","tabelas-precos":"tabelas-precos","core~dashboard":"core~dashboard","dashboard":"dashboard","fv-pedidos~pedidos":"fv-pedidos~pedidos","fv-pedidos":"fv-pedidos","pedidos":"pedidos","landings~paginas~posts":"landings~paginas~posts","landings":"landings","paginas":"paginas","posts":"posts","marcas":"marcas","precos":"precos","integracoes":"integracoes","transacoes":"transacoes","personalizacoes":"personalizacoes","core-login":"core-login","core":"core"}[chunkId]||chunkId) + "." + {"caracteristicas~categorias~clientes~configuracoes~core~core-login~dashboard~formas-entregas~formas-p~ec1d178a":"f27970f5","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~c35de80f":"29435032","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~aee28681":"9e8205d1","caracteristicas~personalizacoes":"b1fe65aa","caracteristicas":"1c3e03ef","categorias~usuarios":"0e1c338e","categorias":"4d3fed45","usuarios":"b45bafa7","clientes":"6b460dd7","configuracoes~formas-entregas~formas-pagamentos~produtos~regras-fretes~regras-precos~tabelas-precos":"556876be","configuracoes":"3b449f68","formas-entregas":"39a6062c","formas-pagamentos":"f8a24230","produtos":"dfa54ac1","regras-fretes":"047965d0","regras-precos":"257b370a","tabelas-precos":"d11ac09e","core~dashboard":"620ac81f","dashboard":"a475d7d0","fv-pedidos~pedidos":"95b4c74c","fv-pedidos":"ef389007","pedidos":"d6e0c31f","landings~paginas~posts":"d96b1460","landings":"1392a1ab","paginas":"a8bbe425","posts":"f2a54121","marcas":"88be054c","precos":"892d9928","integracoes":"752bf699","transacoes":"2cf7a3cf","personalizacoes":"4988a2d8","core-login":"d4909d7b","core":"e93a3a05"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~c35de80f":1,"caracteristicas":1,"categorias~usuarios":1,"categorias":1,"clientes":1,"configuracoes~formas-entregas~formas-pagamentos~produtos~regras-fretes~regras-precos~tabelas-precos":1,"configuracoes":1,"formas-entregas":1,"produtos":1,"regras-fretes":1,"regras-precos":1,"tabelas-precos":1,"dashboard":1,"fv-pedidos":1,"pedidos":1,"landings~paginas~posts":1,"marcas":1,"personalizacoes":1,"core-login":1,"core":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"caracteristicas~categorias~clientes~configuracoes~core~core-login~dashboard~formas-entregas~formas-p~ec1d178a":"caracteristicas~categorias~clientes~configuracoes~core~core-login~dashboard~formas-entregas~formas-p~ec1d178a","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~c35de80f":"caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~c35de80f","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~aee28681":"caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~aee28681","caracteristicas~personalizacoes":"caracteristicas~personalizacoes","caracteristicas":"caracteristicas","categorias~usuarios":"categorias~usuarios","categorias":"categorias","usuarios":"usuarios","clientes":"clientes","configuracoes~formas-entregas~formas-pagamentos~produtos~regras-fretes~regras-precos~tabelas-precos":"configuracoes~formas-entregas~formas-pagamentos~produtos~regras-fretes~regras-precos~tabelas-precos","configuracoes":"configuracoes","formas-entregas":"formas-entregas","formas-pagamentos":"formas-pagamentos","produtos":"produtos","regras-fretes":"regras-fretes","regras-precos":"regras-precos","tabelas-precos":"tabelas-precos","core~dashboard":"core~dashboard","dashboard":"dashboard","fv-pedidos~pedidos":"fv-pedidos~pedidos","fv-pedidos":"fv-pedidos","pedidos":"pedidos","landings~paginas~posts":"landings~paginas~posts","landings":"landings","paginas":"paginas","posts":"posts","marcas":"marcas","precos":"precos","integracoes":"integracoes","transacoes":"transacoes","personalizacoes":"personalizacoes","core-login":"core-login","core":"core"}[chunkId]||chunkId) + "." + {"caracteristicas~categorias~clientes~configuracoes~core~core-login~dashboard~formas-entregas~formas-p~ec1d178a":"31d6cfe0","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~c35de80f":"54fe710d","caracteristicas~categorias~clientes~configuracoes~dashboard~formas-entregas~formas-pagamentos~fv-ped~aee28681":"31d6cfe0","caracteristicas~personalizacoes":"31d6cfe0","caracteristicas":"7892464d","categorias~usuarios":"cfcc99dd","categorias":"7892464d","usuarios":"31d6cfe0","clientes":"31f12602","configuracoes~formas-entregas~formas-pagamentos~produtos~regras-fretes~regras-precos~tabelas-precos":"7892464d","configuracoes":"ae2f42e3","formas-entregas":"308aa786","formas-pagamentos":"31d6cfe0","produtos":"3e37a04f","regras-fretes":"25586228","regras-precos":"25586228","tabelas-precos":"25586228","core~dashboard":"31d6cfe0","dashboard":"ab4fd068","fv-pedidos~pedidos":"31d6cfe0","fv-pedidos":"92335ed3","pedidos":"87bcbe9c","landings~paginas~posts":"7892464d","landings":"31d6cfe0","paginas":"31d6cfe0","posts":"31d6cfe0","marcas":"7892464d","precos":"31d6cfe0","integracoes":"31d6cfe0","transacoes":"31d6cfe0","personalizacoes":"d03b805e","core-login":"cf1c2e74","core":"b2b0fb5d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
